<template>
	<div>
		Configuration:
		<streamer v-model="config.streamer"></streamer>
		<output-config v-model="config.output"></output-config>
	</div>
</template>

<script>

import Streamer from "./configuration/Streamer"
import OutputConfig from './configuration/Output'

export default {
	components: {
		Streamer,
		OutputConfig
	},
	props: ["value"],
	data() {
		return {
			config: this.value
		}
	},
	created: function() {
		this.$watch("config", function(newVal) {
			this.$emit("input", newVal);
		}, {deep: true});
	}
}
</script>